import angular from 'angular'

import commandeCtrl from './commande.controller'
import commandeRoutes from './commande.routes'
import commandeRun from './commande.run'

const name = 'routingConsultCommande'

angular.module(name, [])
  .controller('commandeCtrl', commandeCtrl)
  .config(commandeRoutes)
  .run(commandeRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/commande/commande.module.js